import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Masterclass } from "@customTypes/masterclass";

import { masterclassQKeys } from "./queryKeys";

interface GetMasterclassesProps {
  provider_id?: string;
  isEnabled?: boolean;
}

export const useGetMasterclasses = ({
  provider_id,
  isEnabled = true,
}: GetMasterclassesProps = {}) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: masterclassQKeys.classesWithFilters({ provider_id }),
    queryFn: async () => {
      const { data } = await api.get<Masterclass[]>("masterclass/", {
        params: {
          provider_id: provider_id,
        },
      });

      return data;
    },
    enabled: isEnabled,
    onError: (res: any) => {
      console.error("[From Get Masterclasses]", res);
      handleErrors(res, "query");
    },
  });
};
